<template>
  <div class="container" v-if="!loading">
    <div class="card">
      <img src="/static/img/icons/wav-logo.png" alt="logo" height="30px" />
      <div class="message" v-if="isSignedIn">
        <h2 class="success">Successfully Logged In!</h2>
        <p>Welcome back! You are now signed in.</p>
      </div>
      <div class="message" v-else>
        <h2 class="error">Login link has been expired</h2>
        <p>Please check your login credentials or try signing in again.</p>
      </div>
      <a class="button" v-if="!isSignedIn" href="/login">
        Sign In
      </a>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './browser-extension/firebaseConfig';
import axios from 'axios'; 
import { createCustomToken } from '../../api';

export default {
  data() {
    return {
      errorMessage: null,
      isSignedIn: false,
      loading: true,
    };
  },
  async created() {
    this.loading = true;
    this.initializeFirebase();
    await this.handleEmailSignIn();
  },
  methods: {
    initializeFirebase() {
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
    },
    async handleEmailSignIn() {
      const auth = firebase.auth();
      const email = this.getEmailForSignIn();

      if (!email) {
        this.promptForEmail();
        return;
      }

      try {
        const result = await auth.signInWithEmailLink(email, window.location.href);
        console.log('User signed in successfully:', result.user);

        this.isSignedIn = true;
        await this.redirectToProfile();
      } catch (error) {
        this.handleSignInError(error);
      }finally{
        this.loading = false;
      }
    },
    getEmailForSignIn() {
      // Use email stored locally or prompt if missing
      // get query parameters email
      const email = new URLSearchParams(window.location.search).get('email');
      return window.localStorage.getItem('emailForSignIn') || email || "";
    },
    promptForEmail() {
      const email = prompt('Please provide your email for confirmation');
      if (email) {
        window.localStorage.setItem('emailForSignIn', email);
      }
    },
    async redirectToProfile() {
      try {
        const userCustomToken = await this.getUserProfileDetails();
        // 
        console.log('Custom User Token:', userCustomToken);

        // Redirect after 5 seconds
        this.$router.push(`/profile?userTokenFirebase=${userCustomToken}`);
        
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    },
    async getUserProfileDetails() {
      const user = firebase.auth().currentUser;
      const uid = user ? user.uid : null; 
      
      try {
        const response = await axios.post(createCustomToken, { uid });
        console.log("RESULT", response.data); // Log only the data
        return response.data.token; // Assuming response structure has 'token'
      } catch (error) {
        console.error('Error fetching profile details:', error);
        throw new Error('Failed to fetch user profile details.');
      }
    },
    handleSignInError(error) {
      this.isSignedIn = false;
      this.errorMessage = 'Error completing sign-in.';
      console.error('Error completing sign-in:', error);
    },
    toggleSignIn() {
      if (this.isSignedIn) {
        firebase.auth().signOut().then(() => {
          this.isSignedIn = false;
        });
      } else {
        this.handleEmailSignIn();
      }
    },
  },
};
</script>

  
  <style scoped>
  .container {
    display: flex;
    justify-content: center;
    align-items: center; 
    height: 100vh;
  }
  
  .card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    width: 300px;
  }
  
  .logo {
    width: 100px;
    height: auto;
    margin-bottom: 20px;
  }
  
  .message {
    margin-bottom: 20px;
  }
  
  .success {
    color: #4caf50; /* Green color for success */
  }
  
  .error {
    color: #f44336; /* Red color for error */
    background-color: black !important;
    padding: 10px 20px;
  }
  
  .button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    text-decoration: none;
  }
  
  .button:hover {
    background-color: #0056b3;
  }
  </style>
  


// WEBPACK FOOTER //
// completeSignin.vue?5b179651